// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Droppable, DragDropContext } from '@hello-pangea/dnd';
import { Box } from '@mantine/core';

export const FakeDragDropContext = ({ children }: { children: ReactNode }) => (
  <DragDropContext
    onDragEnd={
      // oxlint-disable-next-line no-empty-function
      () => {}
    }
  >
    <Droppable droppableId="unused">{(provided) => <Box ref={provided.innerRef}>{children}</Box>}</Droppable>
  </DragDropContext>
);
